export default __webpack_public_path__ + "static/media/522.cbc02aea.png";